<template>
  <form class="t-set-timezone" @submit.stop.prevent="Submit()">
    <h2>{{report.title}}</h2>
    <div class="t-inputBox">
      <div class="t-input "
           :class="{_error: item.error}"
           v-for="(item, index) in form"
           :key="index">
        <label :for="item.name">{{item.label}}</label>
        <textarea v-if="item.type === 'textarea'" :id="item.name" v-model="item.value" :placeholder="item.placeholder" @focus="Focus(index)"></textarea>
      </div>
      <div class="t-input">
          <input type="checkbox" v-model="personalInfo"
                 id="personalInfo" class="t-checkbox">
          <label for="personalInfo">
            {{ report.personalData_1 }}
            <a href="/terms_service" target="_blank" download rel="nofollow">{{ report.personalData_2 }}</a>

            {{ report.personalData_3 }}
            <a href="/terms_service" target="_blank" download rel="nofollow">{{ report.personalData_4 }}</a>
          </label>
      </div>
    </div>
    <button class="t-btn" :disabled="!personalInfo" :class="{_disabled: disabledBtn}"><span>{{report.buttonTitle}}</span></button>
  </form>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {mapActions} from 'vuex';
  import {store} from '../../store'

  export default {
    props: ['props'],
    data(){
      return {
        urlPersonalData: window.location.protocol + '//api.' + window.location.host + '/handbook/personal_data',
        urlUserAgreement: window.location.protocol + '//api.' + window.location.host + '/handbook/user_agreement',
        url: 'https://' + window.location.host,
        disabledBtn: false,
        action: process.env.NODE_ENV !== 'production' ? 'report.json' : 'report',
        form: [
          {
            type: 'textarea',
            label: store.getters['staticText/report'].textTitle,
            name: 'report',
            searchable: false,
            value: '',
            placeholder: '',
            error: false,
            pattern: ''
          },
        ],
        personalInfo: false,
      }
    },
    computed: {
      ...mapGetters('profile', ['user']),
      ...mapGetters('staticText', ['report']),
      validated() {
        return this.form[1].checked;
      }
    },
    methods: {
      ...mapActions('modal', ['modalDialogClose']),
      ...mapActions('msg', ['showMsg']),
      Submit(){
        this.disabledBtn = true;

        let is_valid = true;

        for(let i = 0; i < this.form.length; i++){
          if(this.form[i].pattern !== '') {
            if (!this.form[i].pattern.test(this.form[i].value)) {
              this.form[i].error = true;
              is_valid = false;
            }
          } else{
            if (this.form[i].value === '') {
              this.form[i].error = true;
              is_valid = false;
            }
          }
        }

        if(!this.personalInfo){
          is_valid = false;
          this.disabledBtn = false;
        }

        if(is_valid){
          let fd = new FormData();

          for(let i = 0; i < this.form.length; i++){
            fd.append(this.form[i].name, this.form[i].value)
          }

          fd.append('user_id', this.props['id']);

          this.$http.post(this.action, fd)
            .then(response => {
              this.disabledBtn = false;
              this.modalDialogClose();
              this.showMsg(this.report.msgSuccess)
            }, response => {
              this.modalDialogClose();
              this.showMsg('Упс, что-то пошло не так, попробуйте позже')
            });
        }
      },
      Focus(i){
        this.form[i].error = false;
      }
    }
  }
</script>

<style lang="sass">
  .t-set-timezone
    width: 320px
    padding: 24px
    @extend %substrate
    &__help
      font-size: 13px
      text-align: justify
      margin-bottom: 10px
</style>



// WEBPACK FOOTER //
// src/vue_components/ModalDialog/Report.vue